import React from "react";
import { ContactData } from "../../constants/interfaces";

interface ContactProps  {
  data : ContactData
}

export const Contact = (props : ContactProps) => {
  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="">
            <div className="row">
              <div className="social">
                <ul>
                <li>
                    <a href={props.data ? "mailto:" + props.data.email : "/"} target="_blank" rel="noreferrer">
                      <i className="fa fa-envelope"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.linkedIn : "/"} target="_blank" rel="noreferrer">
                      <i className="fa fa-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.instagram : "/"} target="_blank" rel="noreferrer">
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
